import { addDays } from 'date-fns';

/** Resolve the calendar date for a JS weekday (0=Sun … 6=Sat) within the week containing `weekStart`. */
export function dateForDayOfWeekInWeek(weekStart: Date, dayOfWeek: number): Date {
  for (let i = 0; i < 7; i++) {
    const candidate = addDays(weekStart, i);
    if (candidate.getDay() === dayOfWeek) return candidate;
  }
  return weekStart;
}

export const WEEKDAY_SHORT_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;
